/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2020/3/17
 * Time: 13:27
 * Desc: 新增/编辑直播
 */

import { Component, Vue, Watch } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import type { ElTree } from 'element-ui/types/tree';
import type { ElUpload } from 'element-ui/types/upload';
import { textChangeRangeIsUnchanged } from 'typescript';
import { IPSService } from '@/services/ipsServices';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import { appEnvConfig } from '@/configs/appConfigs';
import { EmpServiceAPIActions } from '@/services/empService';
import validateParams from '@/library/utils/paramFilter';
import BatchSetup from '@/views/components/batchSetup/batch.vue';
import GoodsLink from '@/views/components/goodsLink/goodsLink.vue';
import baseAPIService, { HttpErrorCode } from '@/services/base/baseAPIService';
import importBatchSet from '@/views/components/importBatchSet';
import { noop, toDecimal2 } from '@/util';

import { Functions } from '@/library/utils/functions';
import NewSelectSite from '@/views/components/newSelectSIte';

interface uploadImgType {
	imageId: number;
	sort: number;
	imageUrl: string;
}

// 	直播状态 101: 直播中, 102: 未开始, 103: 已结束, 104: 禁播, 105: 暂停中, 106: 异常, 107: 已过期
export enum LIVE_STATE {
	LIVE_ON = 101,
	NO_START,
	END,
	CLOSE,
	PAUSE,
	ERROR,
	EXPIRED,
}
// 0 未开始	1直播中	2直播结束	3活动过期
export enum LIVE_EDIT_STATE {
	NO_START = 0,
	LIVE_ON,
	END,
	EXPIRED,
}

// 落地页商品是否展示 0不展示 1直播前不展示 2展示
export enum LIVE_GOODS_CONFIG {
	NO_SHOW,
	LIVE_BEFORE,
	SHOW,
}
// 直播前商品是否可以购买开关 0直播前不能购买 1直播前可以购买
export enum LIVE_GOODS_BUY {
	NOT_BEY,
	BUY,
}
// 直播前商品可以购买的情况下以什么价格购买 1牌价 2直播价
export enum LIVE_ORDER_PRICE {
	PRICE = 1,
	LIVE,
}

/**
 * 编辑的原则，过期都不可编辑
 */

@Component({
	components: {
		NoAuth,
		BatchSetup,
		GoodsLink,
	},
})
export default class EditVideo extends Vue {
	platformVersion: number;
	/* 数据 */
	@Watch('liveShowImageList', { immediate: true })
	onPropagandaPicListChange(n: uploadImgType[], o) {
		if (o && o.length === 0 && this.editVideoInfo.lvId) {
			return;
		}
		if (n && n.length && JSON.stringify(n) !== JSON.stringify(o)) {
			const param = {
				lvId: this.editVideoInfo.lvId,
				imageList: n.map((val, ind) => {
					return {
						imageId: val.imageId,
						sort: ind + 1,
					};
				}),
			};
			IPSService.liveViewImagesSort({ postParams: param }).then(() => {
				console.log('排序提交成功！');
			});
		}
	}

	$refs: {
		editVideoInfoBase: ElForm;
		linkLiveRoom: ElForm;
		selectSiteTree: ElTree<any, any>;
		fileUpload: ElUpload;
	};

	get openSite() {
		return ` 已选${this.editVideoInfo.siteList.length}家`;
	}

	get lvEndTime() {
		return this.selectLiveRoom ? (this.selectLiveRoom.lvEndTime = moment(this.selectLiveRoom.lvEndTime * 1000).format('YYYY-MM-DD HH:mm')) : '?';
	}

	// 控制开播云店和关联直播间项 （保存后就不可编辑）
	get baseEdit() {
		return !!this.lvId;
	}

	// 过期的权限控制(都不可编辑)
	get liveTimeOut() {
		return !this.baseEdit ? false : this.type === 2 ? true : this.editVideoInfo.lvState === LIVE_EDIT_STATE.EXPIRED;
	}

	// 开播网点，直播活动时间，同步直播间信息 (未开始之后的状态，不可编辑)
	get getLiveState() {
		return !this.baseEdit ? false : this.editVideoInfo.lvState === LIVE_EDIT_STATE.LIVE_ON || this.editVideoInfo.lvState === LIVE_EDIT_STATE.END;
	}

	get getSyncGoodSort() {
		return !this.baseEdit ? false : this.editVideoInfo.lvState === LIVE_EDIT_STATE.END;
	}

	get getEndState() {
		return !this.baseEdit ? false : this.editVideoInfo.lvState === LIVE_EDIT_STATE.LIVE_ON;
	}

	/**
	 * corpId
	 */
	public corpId = baseAPIService.resolveCorpId();

	// ID
	public lvId = null;

	// 类型
	public type = null;
	// 落地页loading
	public backgroundPageLading = false;

	// 编辑直播宣传文件选中的index
	public liveShowSelectIndex = null;

	public isCustom = false;

	public liveConfig = {
		productDisplay: LIVE_GOODS_CONFIG.NO_SHOW,
		lvOrder: LIVE_GOODS_BUY.BUY,
		lvOrderPrice: LIVE_ORDER_PRICE.PRICE,
		shippingState: 0,
	};

	public liveGoodsBuyText = [
		{
			value: LIVE_GOODS_BUY.BUY,
			text: '可购买',
		},
		{
			value: LIVE_GOODS_BUY.NOT_BEY,
			text: '不可购买',
		},
	];

	public liveGoodsConfigText = [
		{ value: LIVE_GOODS_CONFIG.NO_SHOW, text: '不展示' },
		{ value: LIVE_GOODS_CONFIG.LIVE_BEFORE, text: '直播前不展示' },
		{ value: LIVE_GOODS_CONFIG.SHOW, text: '展示' },
	];

	public liveOrderPriceText = [
		{ value: LIVE_ORDER_PRICE.PRICE, text: '牌价' },
		{ value: LIVE_ORDER_PRICE.LIVE, text: '直播价' },
	];

	// 直播状态 101: 直播中, 102: 未开始, 103: 已结束, 104: 禁播, 105: 暂停中, 106: 异常, 107: 已过期
	liveStateText = {
		[LIVE_STATE.LIVE_ON]: '直播中',
		[LIVE_STATE.NO_START]: '未开始',
		[LIVE_STATE.END]: '已结束',
		[LIVE_STATE.CLOSE]: '禁播',
		[LIVE_STATE.PAUSE]: '暂停中',
		[LIVE_STATE.ERROR]: '异常',
		[LIVE_STATE.EXPIRED]: '已过期',
	};

	public onAddGoodsAsyncPopShowFlag = false;
	get liveStatePrevConfig() {
		switch (this.editVideoInfo.lvState) {
			case LIVE_EDIT_STATE.NO_START:
				return {
					text: `${this.selectLiveRoom.lvBeginTime} 准时开播`,
					color: '#3e6ef7',
				};
			case LIVE_EDIT_STATE.LIVE_ON:
				return {
					text: '进入直播间',
					color: '#FF6200',
				};

			case LIVE_EDIT_STATE.END:
				return {
					text: `${this.selectLiveRoom.lvBeginTime} 准时开播`,
					color: '#3e6ef7',
				};
			case LIVE_EDIT_STATE.EXPIRED:
				return {
					text: '直播已结束，点击看回放',
					color: '#52CC6F',
				};
			default:
				return { text: '', color: '' };
		}
	}

	get getLiveRoomPrice() {
		const priceObject = {};
		this.liveGoodsList.forEach((item, index) => {
			const price = item.skuItems.map((i) => {
				return +i.price;
			});
			const max = toDecimal2(Math.max.apply(Math, price)) || '';
			const min = toDecimal2(Math.min.apply(Math, price)) || '';
			priceObject[index] = max === min ? `￥${max}` : `￥${min} ~ ` + `￥${max}`;
		});

		return priceObject;
	}

	public siteDialogLoading = false;
	public liveRoomDialogLoading = false;
	public ipsStoreList = [];
	public sgId = null;

	/**
	 * 直播商品
	 */
	public syncGoodsLoading = false;
	public liveGoodsPage = 1;
	public liveGoodsPageSize = 10;

	public liveGoodsTotal = 0;

	/**
	 * 直播Id
	 * @type {number}
	 */
	public videoId = 0;

	/**
	 * 内容是否显示
	 * @type {boolean}
	 */
	public isContentBodyShow = true;

	/**
	 * 图片上传地址
	 * @type {string}
	 */
	public fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

	// 文件上传

	public fileUploadUrl = `${Functions.ipsHostUrlApi()}/admin/live/view/products/import`;

	public uploadFileName = '';

	public upLoadFileLoading = false;

	get fileUploadData() {
		return {
			lvId: this.editVideoInfo.lvId,
			sendToId: `${appEnvConfig.NODE_ENV}editVideo${this.$store.state.empCode}`,
			corpId: this.corpId,
		};
	}

	/**
	 * token
	 * @type {{Authorization: string}}
	 */
	public tokenData: ItemObject = {
		Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
	};

	isDisplayInActivityCenter = true; // 展示在活动中心
	isDisplayInPeriodical = false; // 展示在期刊页

	// 选中的直播间信息
	public selectLiveRoom = null;
	/**
	 * 新建/编辑直播表单
	 */
	public editVideoInfo: {
		_liveInterval: string;
		lvId: number;
		shareCardPicture: string;
		_roomName: string;
		qikanImage: string;
		lvName: string;
		sgId: string;
		sharePicture: string;
		actImage: string;
		siteList: any[];
		roomId: string | number;
		pointsType?: number;
		lvState: number;
	} = {
			lvId: 0,
			lvName: '', // 直播名称
			sgId: '', // 开播云店
			_roomName: '',
			siteList: [], // 网点数量
			roomId: '',
			_liveInterval: '', // 直播活动期间
			shareCardPicture: '', // 分享卡片封面
			sharePicture: '', // 分享海报封面
			actImage: '', // 活动封面
			qikanImage: '', // 期刊封面
			lvState: 1,
			pointsType: 1,
		};

	public editVideoInfoCopy = null;
	/**
	 * 表单验证规则
	 */
	public editVideoInfoRules: ItemObject = {
		lvName: [{ required: true, trigger: ['blur', 'change'], message: '请输入直播名称' }],
		sgId: [{ required: true, message: '请选择开播云店' }],
		siteList: [{ required: true, message: '请选择开播网点' }],
		_roomName: [{ required: true, message: '请选择关联直播间' }],
		_liveInterval: [
			{
				type: 'array',
				required: true,
				validator: this.validLiveInterval,
				trigger: 'change',
			},
		],
		shareCardPicture: [{ required: true, message: '请选择分享卡片封面图片', trigger: 'change' }],
		sharePicture: [{ required: true, message: '请选择分享海报封面图片', trigger: 'change' }],
	};

	getSummaries(param) {
		const { columns, data } = param;
		const sums = [];
		columns.forEach((column, index) => {
			if (index === 0) {
				sums[index] = '总价';
				return;
			}
			const values = data.map(item => Number(item[column.property]));
			if (!values.every(value => Number.isNaN(value))) {
				sums[index]
					= values
						.map(i => i * 100)
						.reduce((prev, curr) => {
							const value = Number.parseInt(`${Number(curr)}`);
							if (!Number.isNaN(value)) {
								return Number.parseInt(`${Number(prev)}`) + Number.parseInt(`${Number(curr)}`);
							} else {
								return Number.parseInt(`${Number(prev)}`);
							}
						}, 0) / 100;

				if (index === 1 || index === 2 || index === 5) {
					sums[index] = '-';
				}
			} else {
				sums[index] = '-';
			}
		});
		return sums;
	}

	/**
	 * 时间数据的验证
	 * @param rule
	 * @param value
	 * @param callback
	 */
	validLiveInterval(rule, value, callback) {
		if (!value || value.length === 0) {
			return callback(new Error('请选择直播活动时间'));
		} else if (moment(this.selectLiveRoom.lvBeginTime).valueOf() < moment(value[0]).valueOf() || moment(this.selectLiveRoom.lvEndTime).valueOf() > moment(value[1]).valueOf()) {
			return callback(new Error('直播活动的结束时间需晚于直播间的开播结束时间'));
		} else {
			return callback();
		}
	}

	// 第二步的数据
	public liveShowImageList: uploadImgType[] = [];

	public liveGoodsList: any[] = [];
	public allLiveGoodsList: any[] = [];

	/**
	 * 图片放大弹窗是否显示
	 * @type {boolean}
	 */
	public isMagnifyPopShow = false;

	/**
	 * 图片放大弹窗图片
	 */
	public isMagnifyPopImg = '';

	/**
	 * 步骤一是否显示
	 * @type {boolean}
	 */
	public isStepOneShow = true;

	/**
	 * 选择直播间弹窗是否显示
	 * @type boolean
	 */
	public isChooseLiveRoomPopShow = false;

	// 关联直播间的弹窗

	public linkLiveRoomAsyncPopShow = false;

	/**
	 * 选择网点的切换选中的网点
	 */

	public findNodeList: any[] = [];

	public findNodeListSiteCode = [];
	/**
	 * 网点树列表
	 * @type {any[]}
	 */
	public siteTreeList: Array<ItemObject> = [];

	/**
	 * 树的默认配置
	 * @type {{children: string; label: string}}
	 */
	public defaultProps: ItemObject = {
		children: 'children',
		label: 'name',
	};

	/**
	 * 选择网点弹窗是否显示
	 * @type {boolean}
	 */
	public isChooseSitePopShow = false;

	/**
	 * 刘海屏是否显示
	 * @type {boolean}
	 */
	public isBangsShow = true;

	/**
	 *预览落地页弹窗是否显示
	 * @type {string}
	 */
	public isGoodsAsyncPopShow = false;

	// 预览的图片

	public previewBackgroundImg = '';

	public linkLiveForm = {
		roomId: '',
		lvTime: [],
	};

	// 批量设置库存和价格
	public batchSetting = false;

	/**
	 * 商品连接生成工具弹窗是否显示
	 * @type {string}
	 */
	public isGoodsLinkPopShow = false;

	//  直播间弹窗数据
	public liveRoomPage = 1;
	public liveRoomPageSize = 10;
	public liveRoomTotalCount = 0;
	public liveRoomList = [];
	public liveRoomKeywords = '';
	public onLiveRoomSizeChange(val) {
		this.liveRoomPageSize = val;
		this.getLiveRoomList();
	}

	public onLiveRoomPageChange(val) {
		this.liveRoomPage = val;
		this.getLiveRoomList();
	}

	public handleLiveRoomSearch() {
		this.getLiveRoomList();
	}

	// 网点的数据和方法
	public sitePage = 1;
	public sitePageSize = 10;
	public siteTotalCount: number = null;
	public siteList = [];
	public selectSiteList = [];
	public siteKeywords = '';
	/**
	 * 网点列表是否全选
	 * @type {boolean}
	 */
	public isCheckedAll = false;

	// 临时变量，用老储存编辑直播商品的临时数据
	public temporaryVariable = null;

	public cloneList: any[][] = [];

	public onSitePageChange(val) {
		this.sitePage = val;
		this.getSiteList();
	}

	public onSiteSizeChange(val) {
		this.sitePageSize = val;
		this.getSiteList();
	}

	public onSelectedAll(): void {
		const tempList: any = JSON.parse(JSON.stringify(this.selectSiteList));
		const allSiteList: any = JSON.parse(JSON.stringify(this.siteList));
		if (this.isCheckedAll) {
			allSiteList.forEach((item) => {
				item.isSelected = true;
				if (!this.findExistedItem(item.siteCode)) {
					tempList.push(item);
				}
			});
		} else {
			allSiteList.forEach((item: any) => {
				tempList.forEach((sItem: any, index) => {
					if (item.siteCode === sItem.siteCode) {
						tempList.splice(index, 1);
					}
				});
				item.isSelected = false;
			});
		}
		this.selectSiteList = tempList;
		this.siteList = allSiteList;
	}

	public linkLiveRoomDialogConform() {
		this.$refs.linkLiveRoom.validate((flag) => {
			if (flag) {
				this.linkLiveRoomAsyncPopShow = false;
				this.editVideoInfo.roomId = +this.linkLiveForm.roomId;
				this.editVideoInfo._roomName = this.linkLiveForm.roomId;
				const select: any = cloneDeep(this.linkLiveForm);
				select.lvBeginTime = moment(select.lvTime[0]).format('YYYY-MM-DD HH:mm');
				select.lvEndTime = select.lvTime[1] / 1000;
				select.flage = true;
				this.selectLiveRoom = select;
			}
		});
	}

	/**
	 *  文件确定上传
	 */
	submitUpload() {
		this.upLoadFileLoading = true;
		this.$refs.fileUpload.submit();
	}

	batchSettingClose() {
		this.exportBtnInfo = {};
		this.$refs.fileUpload.clearFiles();
		this.batchSetting = false;
		this.uploadFileName = '';
		this.upLoadFileLoading = false;
		this.closeSockets();
		this.getLiveViewInfo();
	}

	/**
	 * 选择网点弹窗显示
	 * @returns null
	 */
	public onChooseSitePopShow(): void {
		if (!this.sgId) {
			this.$message.error('请先选择云店');
			return;
		}
		// this.siteTreeList = [];
		// this.getSiteList();
		console.log(this.selectSiteList);
		const selectCodes = this.selectSiteList.map(item => item.siteCode);
		new NewSelectSite()
			.open({
				sgId: this.sgId,
				selectCodes
			})
			.then((res) => {
				this.selectSiteList = res;
				this.editVideoInfo.siteList = res;
			})
	}

	/**
	 * 发现选中的项
	 * @param {string} code
	 * @return {boolean}
	 */
	public findExistedItem(code: string): boolean {
		const list = this.selectSiteList.filter((item) => {
			return item.siteCode === code;
		});
		return list.length > 0;
	}

	/**
	 * 网点弹窗搜索
	 */
	public handleSiteSearch() {
		this.getSiteList();
	}


	/**
	 * 网点数据的选中
	 * @param row
	 */
	public onSiteDialogSelect(row) {
		this.$set(this, 'selectSiteList', row);
	}

	/**
	 * 添加网点列表选中
	 * @return null
	 */
	public onAddHandleSelectionChange(item): void {
		const isItemExisted = this.findExistedItem(item.siteCode);
		let count = 0;
		const tempList = JSON.parse(JSON.stringify(this.selectSiteList));
		if (isItemExisted && !item.isSelected) {
			// 如果存在不选中删除
			tempList.forEach((sItem, index) => {
				if (item.siteCode === sItem.siteCode) {
					tempList.splice(index, 1);
				}
			});
		} else if (!isItemExisted && item.isSelected) {
			// 如果不存在，添加,且为选中状态
			tempList.push(item);
		}
		this.selectSiteList = tempList;
		// 全选和全不选控制
		this.siteList.forEach((item) => {
			if (item.isSelected) {
				count++;
			}
		});
		this.isCheckedAll = count === this.siteList.length;
	}

	/**
	 *  获取网点信息
	 */
	public getSiteList() {


	}

	/**
	 * 设置节点选中状态
	 * @param {string} val
	 * @returns null
	 */
	public setCurrentkey(val: string): void {
		this.$nextTick(() => {
			(this.$refs.selectSiteTree as ElTree<any, any>).setCurrentKey(val);
		});
	}

	// 获取直播橱窗价
	getLiveWindowPrice(item) {
		return item.lvMinPrice !== item.lvMaxPrice ? `￥${toDecimal2(item.lvMinPrice)} ~ ￥${toDecimal2(item.lvMaxPrice)}` : `￥${toDecimal2(item.lvMaxPrice)}`;
	}

	// 获取直播牌价
	getLiveBagePrice(item) {
		return item.productMinOriginPrice !== item.productMaxOriginPrice ? `￥${toDecimal2(item.productMinOriginPrice)} ~ ￥${toDecimal2(item.productMaxOriginPrice)}` : `￥${toDecimal2(item.productMinOriginPrice)}`;
	}

	/**
	 * 选择网点弹窗隐藏
	 * @returns null
	 */
	public onChooseSitePopHide(): void {
		this.isChooseSitePopShow = false;
		this.siteTotalCount = 0;
		this.siteKeywords = '';
		this.sitePage = 1;
		this.sitePageSize = 10;
		this.findNodeListSiteCode = [];
	}

	/**
	 * 选择直播间弹窗显示
	 * @returns null
	 */
	public onChooseLiveRoomShow(): void {
		if (!this.sgId) {
			this.$message.error('请先选择云店');
			return;
		}
		this.getLiveRoomList();
	}

	/**
	 * 选择直播间弹窗隐藏
	 * @returns null
	 */
	public onChooseLiveRoomHide(): void {
		this.isChooseLiveRoomPopShow = false;
	}

	/**
	 * 获取直播间类别
	 */
	public getLiveRoomList() {
		this.liveRoomDialogLoading = true;
		const param = {
			sgId: this.sgId,
			page: this.liveRoomPage,
			pageNum: this.liveRoomPageSize,
			keywords: this.liveRoomKeywords,
		};

		IPSService.wxLiveViewList({ postParams: param }).then(
			(res) => {
				this.liveRoomList = res.list.map((i) => {
					i.lvBeginTime = moment(i.lvBeginTime * 1000).format('YYYY-MM-DD HH:mm');
					return i;
				});
				this.liveRoomTotalCount = res.count;
				this.liveRoomDialogLoading = false;
				this.isChooseLiveRoomPopShow = true;
			},
			(err) => {
				if (err.code === HttpErrorCode.UNLOAD) {
					this.linkLiveRoomAsyncPopShow = true;
				} else {
					this.liveRoomDialogLoading = false;
					this.$message.error('获取直播间列表失败');
				}
			},
		);
	}

	public resynchronization() {
		const param = {
			roomId: this.editVideoInfo.roomId,
			sgId: this.editVideoInfo.sgId,
		};

		IPSService.liveViewUpdateRoomWX({ postParams: param }).then(
			(res) => {
				this.selectLiveRoom = res;
				this.selectLiveRoom.lvBeginTime = moment(this.selectLiveRoom.lvBeginTime * 1000).format('YYYY-MM-DD HH:mm');
				this.$message.success('同步成功');
			},
			() => {
				this.$message.error('获取直播间列表失败');
			},
		);
	}

	/**
	 * 直播间选中
	 */
	public handleLiveRoomSelect(row) {
		if (row.yjLvName) {
			this.$message.error('该直播间已被占用');
			return;
		}
		this.editVideoInfo.roomId = row.roomId;
		this.editVideoInfo._roomName = row.roomName;
		this.selectLiveRoom = row;
		// this.editVideoInfo.shareCardPicture = row.coverImage;
		this.isChooseLiveRoomPopShow = false;
	}

	onAddGoodsAsyncPopShow() {
		this.onAddGoodsAsyncPopShowFlag = true;
	}

	handleGoodsSelect(selectList) {
		if (selectList && selectList.length) {
			const selectCode = selectList.map(i => i.productCode).join(',');
			this.onGoodsAsyncPopShow(selectCode);
		}
	}

	/**
	 * 同步商品信息弹窗显示
	 * @returns null
	 */
	public onGoodsAsyncPopShow(selectCode?) {
		new Promise<void>((resolve): void => {
			if (this.liveGoodsList && this.liveGoodsList.length) {
				this.$confirm('确定要同步商品吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then((res) => {
					if (res === 'confirm') {
						resolve();
					}
				});
			} else {
				resolve();
			}
		}).then(() => {
			this.syncGoodsLoading = true;
			const param = {
				lvId: this.editVideoInfo.lvId,
				roomId: this.editVideoInfo.roomId,
				productCodes: selectCode || undefined,
			};
			IPSService.liveViewProductsUpdate({ postParams: param }).then(
				(res) => {
					if (res) {
						this.getLiveViewInfo().then(() => {
							this.syncGoodsLoading = false;
						});
					} else {
						this.syncGoodsLoading = false;
						this.$message.error('同步商品失败');
					}
				},
				() => {
					this.syncGoodsLoading = false;
					this.$message.error('同步商品失败');
				},
			);
		});
	}

	getLiveViewInfo() {
		return IPSService.liveViewInfo({
			postParams: {
				lvId: this.editVideoInfo.lvId,
				page: this.liveGoodsPage,
				pageNum: this.liveGoodsPageSize,
			},
		}).then(
			(res: any) => {
				this.liveGoodsList = (res.list || []).map((i) => {
					i.edit = false;
					i.openCommission = i.isOpenCommission === 1;
					return i;
				});
				this.liveGoodsTotal = res.count;
				this.syncGoodsLoading = false;
				return res;
			},
			() => {
				this.syncGoodsLoading = false;
				this.$message.error('同步商品失败');
			},
		);
	}

	getLiveAllViewInfo() {
		IPSService.liveViewInfo({
			postParams: {
				lvId: this.editVideoInfo.lvId,
			},
		}).then(
			(res: any) => {
				this.allLiveGoodsList = res.list || [];
			},
			() => {
				this.syncGoodsLoading = false;
				this.$message.error('同步商品失败');
			},
		);
	}

	public onLiveGoodsSizeChange(val) {
		this.cloneList[this.liveGoodsPage] = this.liveGoodsList;
		this.liveGoodsPageSize = val;
		this.getLiveViewInfo();
	}

	public onLiveGoodsPageChange(val) {
		this.cloneList[val] = this.liveGoodsList;
		this.liveGoodsPage = val;
		this.getLiveViewInfo();
	}
	/**
	 * 商品列表的编辑
	 */

	handleEditGood(index: number) {
		this.temporaryVariable = cloneDeep(this.liveGoodsList[index]);
		this.liveGoodsList[index].edit = true;
	}

	handleEditGoodEvent(index) {
		this.handleEditGoodSave(index).then((res) => {
			this.liveGoodsList[index].edit = false;
		});
	}

	/**
	 * 商品列表的保存
	 */
	handleEditGoodSave(index) {
		const goodInfo = this.liveGoodsList[index];
		// 2020.04.20 小航说直播库存要可以设置为0
		if (
			!goodInfo.skuItems.every((i) => {
				return i.price !== 0;
			})
		) {
			this.$message.error('直播价不可设为0');
			return;
		}

		const param = {
			lvId: goodInfo.lvId,
			skId: goodInfo.skId,
			productCode: goodInfo.productCode,
			skuItems: goodInfo.skuItems.map((i) => {
				return {
					sku: i.sku,
					specVal: i.specVal,
					originPrice: i.originPrice,
					price: i.price,
					stock: i.stock,
				};
			}),
		};

		return IPSService.liveViewProductsEdit({ postParams: param }).then(
			(res) => {
				if (res) {
					this.$message.success('更新成功');
				} else {
					this.$message.error('更新失败');
				}
			},
			() => {
				this.$message.error('更新失败');
			},
		);
	}

	/**
	 *
	 * @param index
	 * @param type
	 * @param val
	 */
	handleEditGoodsConfirm(index, type, val) {
		this.liveGoodsList[index].skuItems.map((i) => {
			i[type] = val;
			return i;
		});
		this.handleEditGoodSave(index).then(() => {
			const tv = cloneDeep(this.liveGoodsList[index]);
			tv.edit = false;
			this.temporaryVariable = tv;
		});
	}

	handleEditGoodsCancel(index) {
		// TODO
	}

	/**
	 * 商品类别取消
	 * @param index
	 */
	handleEditGoodCancel(index) {
		this.$confirm('确认取消保存吗？', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning',
		}).then((res) => {
			if (res === 'confirm') {
				this.$set(this.liveGoodsList, index, this.temporaryVariable);
			}
		});
	}

	/**
	 * 预览落地页弹窗显示
	 * @returns null
	 */
	public onGoodsAsyncPopHide(): void {
		this.isGoodsAsyncPopShow = false;
	}

	public linkLiveRoomAsyncPopHide() {
		this.linkLiveRoomAsyncPopShow = false;
	}

	/**
	 * 商品连接生成工具弹窗显示
	 * @returns null
	 */
	public onGoodsLinkPopShow(): void {
		this.isGoodsLinkPopShow = true;
	}

	/**
	 * 商品连接生成工具弹窗显示
	 * @returns null
	 */
	public onGoodsLinkPopHide(): void {
		this.isGoodsLinkPopShow = false;
	}

	/**
	 * 商品连接生成工具弹窗显示
	 * @returns null
	 */
	public onAddGoodsLinkPopHide(): void {
		this.onAddGoodsAsyncPopShowFlag = false;
	}

	/**
	 * 点击树节点
	 * @param { ItemObject } val
	 * @returns null
	 */
	public onHandleNodeClick(val): void {
		this.findNodeList = [];
		this.findNodeSite(val);
		this.findNodeListSiteCode = this.findNodeList.map((i) => {
			return i.code;
		});
		this.setCurrentkey(val.code);
		this.getSiteList();
	}

	public findNodeSite(node) {
		if (Object.prototype.toString.call(node) === '[object Object]') {
			node = [node];
		}
		node.forEach((i) => {
			if (i.isSite) {
				this.findNodeList.push(i);
			}
			if (i.children && !i.isSite) {
				this.findNodeSite(i.children);
			}
		});
	}

	/**
	 * 步骤切换
	 * @returns null
	 */
	public onStepOneShowToggle(): void {
		this.liveGoodsPage = 1;
		// this.liveGoodsPageSize = 10;

		this.backgroundPageLading = true;

		if (!this.isStepOneShow) {
			this.isStepOneShow = !this.isStepOneShow;
			this.backgroundPageLading = false;
			return;
		}

		this.$refs.editVideoInfoBase.validate((flag) => {
			if (flag) {
				const param: any = cloneDeep(this.editVideoInfo);
				param.actBeginTime = moment(this.editVideoInfo._liveInterval[0]).unix();
				param.actEndTime = moment(this.editVideoInfo._liveInterval[1]).unix();

				// 关联直播的判断

				if (this.selectLiveRoom && this.selectLiveRoom.flage) {
					param.isCustom = 1;
					param.lvBeginTime = moment(this.selectLiveRoom.lvTime[0]).unix();
					param.lvEndTime = moment(this.selectLiveRoom.lvTime[1]).unix();
				}

				// 不够选，则删掉两个图片
				if (!this.isDisplayInActivityCenter) {
					param.actImage = '';
				}
				if (!this.isDisplayInPeriodical) {
					param.qikanImage = '';
				}
				// 两个值完全相等，则不需要提交
				if (
					this.editVideoInfoCopy
					&& Object.keys(param).every((i) => {
						if (i === 'siteList' || i === '_liveInterval') {
							return this.editVideoInfoCopy[i].sort().toString() === param[i].sort().toString();
						}
						return this.editVideoInfoCopy[i] === param[i];
					})
				) {
					this.isStepOneShow = !this.isStepOneShow;
					this.getLiveAllViewInfo();
					this.getLiveViewInfo().then(
						(res) => {
							this.isCustom = !!res.isCustom;
							this.liveShowImageList = res.imageList;

							Object.keys(res).map((i) => {
								if (this.liveConfig.hasOwnProperty(i)) {
									this.liveConfig[i] = res[i];
								}
							});

							this.backgroundPageLading = false;
						},
						() => {
							this.backgroundPageLading = false;
						},
					);
					return;
				}
				const postParams = validateParams(param);
				IPSService.liveViewBaseSave({ postParams }).then(
					(res: any) => {
						if (res) {
							this.isStepOneShow = !this.isStepOneShow;
							this.editVideoInfo.lvId = res.lvId;
							this.editVideoInfoCopy = cloneDeep(param);
							this.getLiveViewInfo().then(
								(res) => {
									this.isCustom = !!res.isCustom;
									this.liveShowImageList = res.imageList;

									this.backgroundPageLading = false;
								},
								() => {
									this.backgroundPageLading = false;
								},
							);
						} else {
							this.backgroundPageLading = false;
						}
					},
					() => {
						this.backgroundPageLading = false;
					},
				);
			} else {
				this.$message.error('验证失败');
				this.backgroundPageLading = false;
			}
		});
	}

	/**
	 * 取消
	 */
	public handleStepCancel() {
		this.$confirm('确认退出当前画面？', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			closeOnClickModal: false,
			type: 'warning',
		}).then((r) => {
			if (r && r === 'confirm') {
				this.$router.push('/videoManage');
			}
		});
	}

	/**
	 * 删除图片
	 * @returns null
	 */
	public onDeletePic(key): void {
		this.editVideoInfo[key] = '';
	}

	/**
	 * 删除图片
	 * @returns null
	 */
	public onLiveDeletePic(index, item: uploadImgType): void {
		const param = {
			lvId: this.editVideoInfo.lvId,
			imageId: item.imageId,
		};

		IPSService.liveViewImagesDel({ postParams: param }).then(
			(res) => {
				if (res) {
					this.liveShowImageList.splice(index, 1);
				}
			},
			() => {
				this.$message.error('删除失败');
			},
		);
	}

	/**
	 * 图片上传之前
	 * @param {ItemObject} file
	 * @return boolean
	 */
	public onBeforeUpload(file: ItemObject): boolean {
		const isJpg = file.type === 'image/jpeg';
		const isPng = file.type === 'image/png';
		const isGif = file.type === 'image/gif';
		const LtSize = file.size / 1024 <= 1024;
		if (!isJpg && !isPng && !isGif) {
			this.$message.error('上传图片只能是 JPG/JPEG/PNG/GIF 格式!');
		}
		if (!LtSize) {
			this.$message.error('上传图片大小不能超过 1M');
		}
		return (isJpg || isPng || isGif) && LtSize;
	}

	/**
	 * 图片上传成功时的处理
	 * @param res
	 * @param file
	 */
	public shareCardPictureUploadImgSuccess(res: HttpAPIRetItem<any>, file: any) {
		this.editVideoInfo.shareCardPicture = res.content;
		this.editVideoInfo.actImage = res.content;
	}

	/**
	 * 图片上传成功时的处理
	 * @param res
	 * @param file
	 */
	public sharePictureUploadImgSuccess(res: HttpAPIRetItem<any>, file: any) {
		this.editVideoInfo.sharePicture = res.content;
		this.editVideoInfo.qikanImage = res.content;
	}

	/**
	 * 图片上传成功时的处理
	 * @param res
	 * @param file
	 */
	public actImageUploadImgSuccess(res: HttpAPIRetItem<any>, file: any) {
		this.editVideoInfo.actImage = res.content;
	}

	/**
	 * 图片上传成功时的处理
	 * @param res
	 * @param file
	 */
	public qikanImageUploadImgSuccess(res: HttpAPIRetItem<any>, file: any) {
		this.editVideoInfo.qikanImage = res.content;
	}

	public onPropagandaUploadImgSuccess(res: HttpAPIRetItem<any>, file: any) {
		const param = {
			lvId: this.editVideoInfo.lvId,
			imageUrl: res.content,
			sort: this.liveShowImageList.length + 1,
		};

		IPSService.liveViewImagesAdd({ postParams: param }).then(
			(resp: any) => {
				this.liveShowImageList.push({
					imageId: resp.imageId,
					imageUrl: res.content,
					sort: this.liveShowImageList.length + 1,
				});
			},
			() => {
				this.$message.error('图片上传失败！');
			},
		);
	}

	public onSelectIndex(index) {
		this.liveShowSelectIndex = index;
	}
	/**
	 * 图片上传失败
	 * @return null
	 */

	public uploadImgError() {
		this.$message.error('图片上传失败');
	}

	/**
	 * 图片放大
	 * @return null
	 */
	public onMagnifyPic(key): void {
		this.isMagnifyPopImg = this.editVideoInfo[key];
		this.isMagnifyPopShow = true;
	}

	public onLiveMagnifyPic(item): void {
		this.isMagnifyPopImg = item.imageUrl;
		this.isMagnifyPopShow = true;
	}

	// 下载文件模板
	public handleDownloadTemplate() {
		return IPSService.liveViewInfo({
			postParams: {
				lvId: this.editVideoInfo.lvId,
				page: 0,
				pageNum: 0,
			},
		}).then((res: any) => {
			const liveGoodsList = res.list || [];
			let allGoodLst = [];
			liveGoodsList.forEach((i) => {
				const sku = (i.skuItems || []).map((v) => {
					v.productCode = i.productCode;
					return v;
				});
				allGoodLst = [].concat(allGoodLst, sku);
			});

			Functions.excelMaker({
				columns: [
					{ header: '货号', key: 'productCode', width: 15 },
					{ header: '条码', key: 'sku', width: 30 },
					{ header: '规格', key: 'specVal', width: 20 },
					{ header: '直播价(元)', key: 'price', width: 20 },
					{ header: '库存', key: 'stock', width: 20 },
				],
				data: allGoodLst,
				name: '库存价格数据模板',
			});
		});
	}

	public onBeforeFileUpload(file: ItemObject): boolean {
		const LtSize = file.size / 1024 <= 2048;
		if (!LtSize) {
			this.$message.error('上传图片大小不能超过 2MB!');
		} else {
			this.uploadFileName = file.name;
		}
		return LtSize;
	}

	public onFileUploadImgSuccess(res: HttpAPIRetItem<any>) {
		if (res.content.result) {
			// this.$nextTick(() => {
			//   this.$message.success("文件上传成功");
			//   this.$refs.fileUpload.clearFiles();
			//   this.uploadFileName = "";
			//   this.upLoadFileLoading = false;
			// });
		}
	}

	public uploadFileError() {
		this.$message.error('文件上传失败');
		this.upLoadFileLoading = false;
	}

	closeSockets() {
		this.sockets.unsubscribe('new_msg'); // 取消订阅
		this.$socket.disconnect(); // 断开连接
	}

	public openFileUploadDialog() {
		// this.batchSetting = true;
		// //@ts-ignore
		// this.$socket.connect(); // socket建立连接
		// this.onSokectConnect(); // 打开socket
		importBatchSet
			.open({
				title: '直播商品',
				fromKey: 'live',
				empCode: this.$store.state.empCode,
				postParams: { lvId: this.lvId, page: 0, pageNum: 0 },
				importUrl: `${Functions.ipsHostUrlApi()}/admin/live/view/products/import`,
				importParams: { lvId: this.lvId, corpId: this.corpId },
			})
			.then((result) => {
				if (result.flag) {
					this.getLiveViewInfo();
				}
			}, noop);
	}

	exportBtnInfo: any = {};

	/**
	 * 当组建加载时
	 */
	public created() {
		this.lvId = this.editVideoInfo.lvId = Number.parseInt(this.$route.params.id) || 0;
		this.type = +this.$route.params.type;
		this.platformVersion = +localStorage.getItem('platformVersion');
		// 权限检测
		this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-LIVE-VIEW');
		if (this.isContentBodyShow && this.editVideoInfo.lvId) {
			IPSService.liveViewBaseInfo({
				postParams: { lvId: this.editVideoInfo.lvId },
			}).then((res) => {
				const resp: any = res;

				resp._liveInterval = [resp.actBeginTime * 1000, res.actEndTime * 1000];
				resp._roomName = res.roomName;

				this.selectLiveRoom = {
					roomId: res.roomId,
					roomName: res.roomName,
					lvBeginTime: moment(res.lvBeginTime * 1000).format('YYYY-MM-DD HH:mm'),
					lvEndTime: res.lvEndTime,
					anchorName: res.anchorName,
				};
				this.selectSiteList = res.siteList.map((i) => {
					return { siteCode: i };
				});
				this.sgId = res.sgId;
				this.editVideoInfo = resp;
				this.editVideoInfoCopy = cloneDeep(resp);

				// 期刊checkbox选中的判断
				if (res.qikanImage) {
					this.isDisplayInPeriodical = true;
				}
			});
		}
	}

	liveConfirm() {
		const liveConfigCopy = cloneDeep(this.liveConfig);

		if (liveConfigCopy.productDisplay !== 2) {
			liveConfigCopy.lvOrder = 0;
		}

		// 选择不可购买时，直播前商品可以购买的情况不展示，默认置为1
		if (liveConfigCopy.lvOrder === 0) {
			liveConfigCopy.lvOrderPrice = 1;
		}
		// 把前一页的数据记录下来
		this.liveGoodsList = this.liveGoodsList.concat(this.cloneList.flat()).filter(Boolean);
		// 为防止用户在编辑的状态下直接发布，所以对可能属于编辑状态的还原初始值。
		this.liveGoodsList = this.liveGoodsList.map((i) => {
			if (i.edit) {
				return this.temporaryVariable;
			}
			return i;
		});

		// 判断是否有不符合规则的
		for (let i = 0; i < this.liveGoodsList.length; i++) {
			const item = this.liveGoodsList[i];
			// if (this.getLiveWindowPrice(item) !== this.getLiveRoomPrice[i]) {
			//   this.$message.error("商品" + item.productName + "的直播橱窗价和直播价不一致，请修正！");
			//   return;
			// }
		}
		const productCommissionConfig = this.liveGoodsList.map((v) => {
			return {
				productCode: v.productCode,
				isOpenCommission: Number(v.openCommission),
			};
		});
		IPSService.liveViewPush({
			postParams: { lvId: this.editVideoInfo.lvId, ...liveConfigCopy, productCommissionConfig },
		}).then((res) => {
			if (res) {
				this.$message.success('提交成功');
				this.$router.push('/videoManage');
			}
		});
	}

	/**
	 * 开播云镜点选择
	 * @param e
	 */
	public handleIpsStoreSelectChange(e) {
		this.sgId = e;
		this.editVideoInfo.siteList = [];
		this.editVideoInfo._roomName = '';
		this.editVideoInfo.roomId = null;
	}

	/**
	 * 预览落地页
	 */

	public previewBackground() {
		IPSService.liveViewDisplay({
			postParams: { lvId: this.editVideoInfo.lvId },
		}).then((res: any) => {
			this.previewBackgroundImg = res.lvQrcode;
			this.isGoodsAsyncPopShow = true;
		});
	}

	public mounted() {
		IPSService.getSiteGroupList().then((res) => {
			this.ipsStoreList = res.list;
		});
	}
}
